import AccountDropdown from '@/components/AccountDropdown';
import { BarChart3 } from 'lucide-react';

export default function HeaderBar({ user, logout, userTeams, selectedTeam, onTeamChange }) {
    return (
        <div className="dashboard-header">
            <div className="header-content">
                <div className="header-left">
                    {/*<BarChart3 className="header-icon" />*/}
                    <a href="/"><img className="logo" src="/images/orbit-logo.svg" /></a>
                    <h1 className="header-title"><a href="/">Orbit</a></h1>
                </div>
                <div className="header-right">
                    <AccountDropdown
                        user={user}
                        logout={logout}
                        userTeams={userTeams}
                        selectedTeam={selectedTeam}
                        onTeamChange={onTeamChange}
                    />
                </div>
            </div>
        </div>
    );
}
